import classNames from "classnames";
import { Loader2 } from "lucide-react";
import { Color } from "utils/theme";

export const Spinner = ({ className = "size-12" }) => {
  return (
    <Loader2
      className={classNames("animate-spin", className)}
      stroke={Color.White}
    />
  );
};
